<template>
  <div class="animated fadeIn" v-html="$t('Webportal.Imprint.ContentVue2')">
  </div>
</template>

<script>
export default {
  name: 'Imprint',
  computed: {
    appTarget() {
      return APP_TARGET;
    }
  }
}
</script>
